import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

/* ---- header basket: count + open the drawer ---- */
const basketCount = document.querySelector('[data-bf-basket-count]');
const setCount = (n) => { if (basketCount) basketCount.textContent = String(n); };

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise?.then(({ cart }) => {
    if (cart && typeof cart.totalQuantity === 'number') { setCount(cart.totalQuantity); return; }
    fetch(`${Theme.routes.cart_url}.js`).then((r) => r.json()).then((c) => setCount(c.item_count)).catch(() => {});
  }).catch(() => {});
});

document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-bf-basket]');
  if (!link) return;
  const drawer = document.getElementById('cart-drawer');
  if (drawer && typeof drawer.open === 'function') {
    event.preventDefault();
    drawer.open();
  }
});

/* ---- add a whole set ---- */
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-bf-add-set]');
  if (!button || button.disabled) return;
  event.preventDefault();

  const ids = (button.dataset.variants || '').split(',').map((s) => s.trim()).filter(Boolean);
  if (!ids.length) return;

  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => el.dataset.sectionId).filter(Boolean);

  const deferred = CartLinesUpdateEvent.createPromise();
  button.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add',
    context: 'product',
    lines: ids.map((id) => ({ merchandiseId: id, quantity: 1 })),
    promise: deferred.promise,
  }));

  const label = button.textContent;
  button.disabled = true;
  button.textContent = 'adding…';

  try {
    const body = { items: ids.map((id) => ({ id: Number(id), quantity: 1 })) };
    if (sectionIds.length) body.sections = sectionIds.join(',');
    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body),
    });
    const result = await response.json();
    if (result.status) throw new Error(result.message || result.description || 'Could not add the set');

    const ajaxCart = await fetch(`${Theme.routes.cart_url}.js`).then((r) => r.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
      detail: {
        items: ajaxCart.items,
        source: 'bf-set',
        sourceId: 'bf-set',
        itemCount: ids.length,
        sections: result.sections,
        didError: false,
      },
    });
    setCount(ajaxCart.item_count);
    button.textContent = 'added';
  } catch (error) {
    deferred.reject(error);
    button.textContent = 'try again';
    console.warn('[bf] add set failed', error);
  } finally {
    setTimeout(() => { button.disabled = false; button.textContent = label; }, 1800);
  }
});
